import React from 'react';

import { SppinerIcon } from './styles';

function SpinnerPrimary() {
  return <SppinerIcon />;
}

export default SpinnerPrimary;
